import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Layout from "../../components/layout/Layout";
import { APIURL } from "../../redux/action/config";
import axios from "axios";
import NoImage from "../../assets/images/noimages.jpg";
import { useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import { ManageServiceList } from "../../redux/action/services";
import { upadteMemberships } from "../../redux/action/Memberships";
import { connect } from "react-redux";
import { ToastContainer } from "react-toastify";
import Checkbox from "./../../components/Checkbox";
import Select from "react-select";
import loader from "../../components/loader/loader";
// import SunEditor from "suneditor-react";
// import "suneditor/dist/css/suneditor.min.css"; // Import Sun Editor's CSS File
const initialState = { alt: "", src: "" };

const EditMembership = ({ loading }) => {
  const [activeLoader, setActiveLoader] = useState(false);
  const [{ alt, src }, setPreview] = useState(initialState);
  const [img, setImg] = useState();
  const [btnLoading, setBtnLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const fileHandler = (event) => {
    const { files } = event.target;

    const token = localStorage.getItem("token");
    // Upload Image
    var formdata = new FormData();
    formdata.append("image", event.target.files[0]);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);
    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${APIURL}/api/v1/image`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status == "success") {
          setActiveLoader(false);
          setImg(result.data.images.image);
        }
      })
      .catch((error) => console.log("error", error));

    setPreview(
      files.length
        ? {
          src: URL.createObjectURL(files[0]),
          alt: files[0].name,
        }
        : initialState
    );
    setActiveLoader(true);
  };

  const dispatch = useDispatch();
  const [isCheck, setIsCheck] = useState([]);
  const counts = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  const memberList = useSelector((state) => state.manageservice.list);

  useEffect(() => {
    dispatch(ManageServiceList());
  }, [dispatch]);

  const serviceData = memberList?.data?.shortedServices
    ? memberList?.data?.shortedServices
    : "";

  const [MembershipDetails, setMembershipDetails] = useState();

  const { id } = useParams();

  useEffect(() => {
    if (!id) return;
    setPageLoading(true);
    const token = localStorage.getItem("token");
    var config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(`${APIURL}/api/v1/membership/${id}`, config)
      .then((response) => {
        setMembershipDetails(response.data);
        setPageLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  // const [servicId, setServices] = useState([]);
  // const onPeopleInfo = (id) => {
  //   const index = servicId.indexOf(id);
  //   if (index > -1) {
  //     setServices(servicId.filter((item) => item !== id));
  //   } else {
  //     setServices((oldArray) => {
  //       return [...oldArray, id];
  //     });
  //   }
  // };

  const membership = MembershipDetails?.data?.membership
    ? MembershipDetails?.data?.membership
    : "";

  useEffect(() => {
    setPreview(
      membership
        ? {
          src: APIURL + "/" + membership?.image,
          alt: 'membership_image',
        }
        : initialState
    );
  }, [membership])

  const matched = serviceData
    ? serviceData?.filter((el) => {
      return membership?.service_id
        ? membership?.service_id?.some((f) => {
          return f === el?._id;
        })
        : "";
    })
    : "";

  const unMatched = serviceData
    ? serviceData?.filter(({ id: id1 }) =>
      membership?.service_id
        ? !membership?.service_id?.some((id) => id === id1)
        : ""
    )
    : "";
  const checked = matched ? matched?.map((v) => ({ ...v, checked: true })) : "";
  var FilteredData = checked?.concat(unMatched);

  const selectedServicesIs = membership
    ? membership?.service_id?.map((item) => item)
    : "";

  let test = isCheck?.concat(selectedServicesIs);
  //
  const handleClick = (e) => {
    const { id, checked } = e.target;

    if (checked == false) {
      const index = test.indexOf(id);
      if (index > -1) {
        test.splice(index, 1);
      }
    } else {
      test?.push(id);
    }

    // console.log(checked == false);
    // setIsCheck([...isCheck, id]);
    // if (!checked) {
    //   setIsCheck(isCheck.filter((item) => item !== id));
    // }
  };

  //
  // const initialContent = "";
  // const [content, setContent] = useState(initialContent);

  const serviceOptions = serviceData
    ? serviceData?.map((item) => {
      return {
        value: item?.id,
        label: item?.name,
      };
    })
    : "";

  const selectedSeviceOption = membership?.services
    ? membership?.services?.map((item) => {
      return {
        value: item?.id,
        label: item?.name,
      };
    })
    : "";

  const [allTechs, setAllTechs] = useState(null);
  useEffect(() => {
    if (allTechs === null) {
      setTimeout(() => {
        setAllTechs(selectedSeviceOption);
        setServices(selectedSeviceOption);
      }, 1000);
    }
  }, [selectedSeviceOption, allTechs]);

  const [servicId, setServices] = useState(null);
  const handleSelect = (e) => {
    setServices([...e]);
    setAllTechs([...e]);
  };

  const colourStyles = {
    menuList: (styles) => ({
      ...styles,
      background: "rgba(248, 246, 242, 0.3)",
    }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      background: isFocused ? "#f8f6f2" : isSelected ? "#fff" : undefined,
      zIndex: 1,
    }),
    menu: (base) => ({
      ...base,
      zIndex: 100,
    }),
  };

  // update function after edit to update item
  // update = () => {
  //   let value = this.state.value;
  //   const item = value.filter((ele) =>
  //     ele.id === this.state.editId
  //       ? (ele.value = this.state.editValue)
  //       : ele.value
  //   );

  //   this.setState({ value: item, isEdit: false }, () => {
  //     console.log(this.state.value);
  //   });
  // };

  const [serviceMsg, setServiceMsg] = useState(false);

  return (
    <React.Fragment>
      <ToastContainer autoClose={2000} />
      <Layout title="Edit Memberships" page="editMembership">
        <div
          className="content d-flex flex-column flex-column-fluid"
          id="kt_content"
        >
          <div id="kt_content_container" className="container-fluid">
            {!pageLoading ? (
              <div className="row">
                <div className="col-xl-8 offset-xl-2">
                  <div className="card card-flush h-lg-100">
                    <div className="card-header pt-7">
                      <div className="card-title">
                        <span className="svg-icon svg-icon-1 me-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M20 14H18V10H20C20.6 10 21 10.4 21 11V13C21 13.6 20.6 14 20 14ZM21 19V17C21 16.4 20.6 16 20 16H18V20H20C20.6 20 21 19.6 21 19ZM21 7V5C21 4.4 20.6 4 20 4H18V8H20C20.6 8 21 7.6 21 7Z"
                              fill="black"
                            ></path>
                            <path
                              opacity="0.3"
                              d="M17 22H3C2.4 22 2 21.6 2 21V3C2 2.4 2.4 2 3 2H17C17.6 2 18 2.4 18 3V21C18 21.6 17.6 22 17 22ZM10 7C8.9 7 8 7.9 8 9C8 10.1 8.9 11 10 11C11.1 11 12 10.1 12 9C12 7.9 11.1 7 10 7ZM13.3 16C14 16 14.5 15.3 14.3 14.7C13.7 13.2 12 12 10.1 12C8.10001 12 6.49999 13.1 5.89999 14.7C5.59999 15.3 6.19999 16 7.39999 16H13.3Z"
                              fill="black"
                            ></path>
                          </svg>
                        </span>
                        <h2>Edit Memberships</h2>
                      </div>
                    </div>
                    <div className="card-body pt-5">
                      <Formik
                        initialValues={{
                          name: membership?.name,
                          service_id: servicId,
                          order_Counts: membership?.order_Counts,
                          price: membership.price,
                          priceMonthly: membership.priceMonthly,
                          priceDaily: membership.priceDaily,
                          price1to7Days: membership.price1to7Days,
                          price7to30Days: membership.price7to30Days,
                          vehicleLimit: "",
                          description: membership.description,
                          motorcyclePrice: "",
                          motorcycleAtvPrice: "",
                          bicyclePrice: "",
                          description: membership?.description,
                          additionalDriversPrice: "",
                          vehiclePrice: "",
                          car: "",
                          carPrice: "",
                          additionalDrivers: "",
                          waitingPeriod: membership?.waitingPeriod,
                          firstTimeDiscount: membership?.firstTimeDiscount,
                          golfCartPrice: membership?.golfCartPrice
                        }}
                        onSubmit={(values) => {
                          values.name = values?.name
                            ? values?.name
                            : membership?.name;
                          values.bicyclePrice = values?.bicyclePrice
                            ? values?.bicyclePrice
                            : membership?.bicyclePrice;
                          values.motorcyclePrice = values?.motorcyclePrice
                            ? values?.motorcyclePrice
                            : membership?.motorcyclePrice;
                          values.motorcycleAtvPrice = values?.motorcycleAtvPrice
                            ? values?.motorcycleAtvPrice
                            : membership?.motorcycleAtvPrice;
                          // values.price = values?.price
                          //   ? values?.price
                          //   : membership?.price;
                          values.vehicleLimit = values?.vehicleLimit
                            ? values?.vehicleLimit
                            : membership?.vehicleLimit;
                          values.additionalDrivers = values?.additionalDrivers
                            ? values?.additionalDrivers
                            : membership?.additionalDrivers;
                          values.description = values?.description;
                          values.order_Counts = values?.order_Counts
                            ? values?.order_Counts
                            : membership?.order_Counts;
                          values.additionalDriversPrice =
                            values?.additionalDriversPrice
                              ? values?.additionalDriversPrice
                              : membership?.additionalDriversPrice;
                          values.car = values?.car
                            ? values?.car
                            : membership?.car;
                          values.carPrice = values?.carPrice
                            ? values?.carPrice
                            : membership?.carPrice;
                          values.vehiclePrice = values?.vehiclePrice
                            ? values?.vehiclePrice
                            : membership?.vehiclePrice;
                          values.waitingPeriod = values?.waitingPeriod
                            ? values?.waitingPeriod
                            : membership?.waitingPeriod;
                          values.golfCartPrice = values?.golfCartPrice
                            ? values.golfCartPrice
                            : membership?.golfCartPrice
                          if (img !== "undefined") {
                            values.image = img;
                          } else {
                            values.image = membership?.image;
                          }

                          const payload = {
                            ...values,
                            service_id: !servicId
                              ? membership?.service_id?.map((i) => i?.id)
                              : servicId?.map((i) => i?.value),
                          };
                          if (!payload?.service_id?.length > 0) {
                            setServiceMsg("Service is required");
                            return;
                          }
                          setServiceMsg("");
                          dispatch(
                            upadteMemberships(payload, id, (res) => {
                              setBtnLoading(true);
                              if (res === "error") {
                                setBtnLoading(false);
                              }
                            })
                          );
                        }}
                      >
                        {({
                          values,
                          handleBlur,
                          handleChange,
                          handleSubmit,
                        }) => (
                          <form className="form">
                            <div className="row mb-8">
                              <div className="col-xl-3">
                                <div className="fs-6 fw-bold mt-2 mb-3">
                                  Membership Badge
                                </div>
                              </div>
                              <div className="col-lg-8">
                                <div
                                  className="image-input w-125px h-125px image-input-outline"
                                  style={{
                                    backgroundImage: `url(${src || NoImage})`,
                                  }}
                                >
                                  <label
                                    className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow"
                                    data-kt-image-input-action="change"
                                    data-bs-toggle="tooltip"
                                    title="Change avatar"
                                    data-bs-original-title="Change avatar"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-pencil"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"></path>
                                    </svg>
                                    <input
                                      id="file-input"
                                      accept="image/*"
                                      type="file"
                                      onChange={fileHandler}
                                    />
                                    <input type="hidden" name="avatar_remove" />
                                  </label>
                                  <span
                                    className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow"
                                    data-kt-image-input-action="cancel"
                                    data-bs-toggle="tooltip"
                                    title="Cancel avatar"
                                    data-bs-original-title="Cancel avatar"
                                  >
                                    <i className="bi bi-x fs-2"></i>
                                  </span>
                                  {activeLoader == true ? (
                                    <div
                                      className="d-flex align-items-center justify-content-center h-100"
                                      style={{ background: "#e2e2e270" }}
                                    >
                                      <div
                                        className="spinner-border w-80"
                                        role="status"
                                      >
                                        <span className="visually-hidden">
                                          Loading...
                                        </span>
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                                <div className="form-text">
                                  Allowed file types: png, jpg, jpeg.
                                </div>
                              </div>
                            </div>
                            <div className="row mb-8">
                              <div className="col-xl-3">
                                <div className="fs-6 fw-bold mt-2 mb-3">
                                  Membership Name
                                </div>
                              </div>
                              <div className="col-xl-9 fv-row fv-plugins-icon-container">
                                <input
                                  type="text"
                                  className="form-control form-control-solid"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  name="name"
                                  id="name"
                                  defaultValue={
                                    membership?.name
                                      ? membership?.name
                                      : values.name
                                  }
                                />
                                <div className="fv-plugins-message-container invalid-feedback"></div>
                              </div>
                            </div>
                            {/* <div className="row mb-8">
                              <div className="col-xl-3">
                                <div className="fs-6 fw-bold mt-2 mb-3">
                                  Membership price
                                </div>
                              </div>
                              <div className="col-xl-9 fv-row fv-plugins-icon-container">
                                <input
                                  type="text"
                                  className="form-control form-control-solid"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  name="price"
                                  id="price"
                                  defaultValue={
                                    membership?.price
                                      ? membership?.price
                                      : values.price
                                  }
                                />
                                <div className="fv-plugins-message-container invalid-feedback"></div>
                              </div>
                            </div> */}
                            <div className="row mb-8">
                              <div className="col-xl-3">
                                <div className="fs-6 fw-bold mt-2 mb-3">
                                  Membership Price
                                </div>
                              </div>
                              <div className="col-xl-9 fv-row fv-plugins-icon-container">
                                <div className="row">
                                  <div className="col-4">
                                    <label for="price" className="mb-3">
                                      <b>Yearly Price</b>
                                    </label>
                                    <input
                                      type="number"
                                      step="any"
                                      className="form-control form-control-solid"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      name="price"
                                      id="price"
                                      defaultValue={values.price}
                                      title="yearly price"
                                    />
                                  </div>
                                  <div className="col-4">
                                    <label for="monthly" className="mb-3">
                                      <b> Monthly Price</b>
                                    </label>
                                    <input
                                      type="number"
                                      step="any"
                                      className="form-control form-control-solid"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      name="priceMonthly"
                                      id="priceMonthly"
                                      defaultValue={values.priceMonthly}
                                      title="monthly price"
                                    />
                                  </div>
                                  <div className="col-4">
                                    <label for="priceDaily" className="mb-3">
                                      <b> Daily Price</b>
                                    </label>
                                    <input
                                      type="number"
                                      step="any"
                                      className="form-control form-control-solid"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      name="priceDaily"
                                      id="priceDaily"
                                      defaultValue={values.priceDaily}
                                      title="daily price"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="row mb-8">
                              <div className="col-xl-3">
                                <div className="fs-6 fw-bold mt-2 mb-3">
                                  Rental Duration Pricing
                                </div>
                              </div>
                              <div className="col-xl-9 fv-row fv-plugins-icon-container">
                                <div className="row">
                                  <div className="col-4">
                                    <label for="price1to7Days" className="mb-3">
                                      <b>1-7 Day Price</b>
                                    </label>
                                    <input
                                      type="number"
                                      step="any"
                                      className="form-control form-control-solid"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      name="price1to7Days"
                                      id="price1to7Days"
                                      defaultValue={values.price1to7Days}
                                      title="1-7 day price"
                                    />
                                  </div>
                                  <div className="col-4">
                                    <label for="price7to30Days" className="mb-3">
                                      <b>7-30 Day Price</b>
                                    </label>
                                    <input
                                      type="number"
                                      step="any"
                                      className="form-control form-control-solid"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      name="price7to30Days"
                                      id="price7to30Days"
                                      defaultValue={values.price7to30Days}
                                      title="7-30 day price"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="row mb-8">
                              <div className="col-xl-3">
                                <div className="fs-6 fw-bold mt-2 mb-3">
                                  First Time Discount
                                </div>
                              </div>
                              <div className="col-xl-9 fv-row fv-plugins-icon-container">
                                <div className="row">
                                  <div className="col-4">
                                    <label for="firstTimeDiscount" className="mb-3">
                                      <b>Discount Price</b>
                                    </label>
                                    <input
                                      type="number"
                                      step="any"
                                      className="form-control form-control-solid"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      name="firstTimeDiscount"
                                      id="firstTimeDiscount"
                                      defaultValue={membership?.firstTimeDiscount ? membership.firstTimeDiscount : values.firstTimeDiscount}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="row mb-8">
                              <div className="col-xl-3">
                                <div className="fs-6 fw-bold mt-2 mb-3">
                                  Allowed Orders
                                </div>
                              </div>
                              <div className="membership-form-check col-xl-9 fv-row fv-plugins-icon-container d-flex flex-wrap checkbox">
                                <input
                                  type="text"
                                  className="form-control form-control-solid"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  name="order_Counts"
                                  id="order_Counts"
                                  defaultValue={
                                    values.order_Counts
                                      ? values.order_Counts
                                      : membership?.order_Counts
                                  }
                                />
                              </div>
                            </div>

                            {/* <div className="row mb-8">
                              <div className="col-xl-3">
                                <div className="fs-6 fw-bold mt-2 mb-3">
                                  Vehicle Name
                                </div>
                              </div>
                              <div className="col-xl-9 fv-row fv-plugins-icon-container">
                                <input
                                  type="text"
                                  className="form-control form-control-solid"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  name="car"
                                  id="car"
                                  defaultValue={
                                    membership?.car
                                      ? membership?.car
                                      : values.car
                                  }
                                />
                                <div className="fv-plugins-message-container invalid-feedback"></div>
                              </div>
                            </div> */}
                            <div className="row mb-8">
                              <div className="col-xl-3">
                                <div className="fs-6 fw-bold mt-2 mb-3">
                                  Car Price
                                </div>
                              </div>
                              <div className="col-xl-9 fv-row fv-plugins-icon-container">
                                <input
                                  type="text"
                                  className="form-control form-control-solid"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  name="vehiclePrice"
                                  id="vehicle-price"
                                  defaultValue={
                                    membership?.vehiclePrice
                                      ? membership?.vehiclePrice
                                      : values.vehiclePrice
                                  }
                                />
                              </div>
                            </div>
                            {/* <div className="row mb-8">
                             <div className="col-xl-3">
                               <div className="fs-6 fw-bold mt-2 mb-3">
                                 Car Price
                               </div>
                             </div>
                             <div className="col-xl-9 fv-row fv-plugins-icon-container">
                               <input
                                 type="text"
                                 className="form-control form-control-solid"
                                 onChange={handleChange}
                                 onBlur={handleBlur}
                                 name="carPrice"
                                 id="carPrice"
                                 defaultValue={
                                   membership?.carPrice
                                     ? membership?.carPrice
                                     : values.carPrice
                                 }
                               />
                               <div className="fv-plugins-message-container invalid-feedback"></div>
                             </div>
                           </div> */}

                            {/*  */}

                            <div className="row mb-8">
                              <div className="col-xl-3">
                                <div className="fs-6 fw-bold mt-2 mb-3">
                                  Motorcycle/ATV Price
                                </div>
                              </div>
                              <div className="col-xl-9 fv-row fv-plugins-icon-container">
                                <input
                                  type="text"
                                  className="form-control form-control-solid"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  name="motorcyclePrice"
                                  id="motorcyclePrice"
                                  defaultValue={
                                    membership?.motorcyclePrice
                                      ? membership?.motorcyclePrice
                                      : values.motorcyclePrice
                                  }
                                />
                              </div>
                            </div>
                            <div className="row mb-8">
                              <div className="col-xl-3">
                                <div className="fs-6 fw-bold mt-2 mb-3">
                                  Golf Cart Price
                                </div>
                              </div>
                              <div className="col-xl-9 fv-row fv-plugins-icon-container">
                                <input
                                  type="text"
                                  className="form-control form-control-solid"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  name="golfCartPrice"
                                  id="golfCartPrice"
                                  defaultValue={
                                    membership?.golfCartPrice
                                      ? membership?.golfCartPrice
                                      : values.golfCartPrice
                                  }
                                />
                              </div>
                            </div>
                            {/* <div className="row mb-8">
                              <div className="col-xl-3">
                                <div className="fs-6 fw-bold mt-2 mb-3">
                                  Motorcycle Atv Price
                                </div>
                              </div>
                              <div className="col-xl-9 fv-row fv-plugins-icon-container">
                                <input
                                  type="text"
                                  className="form-control form-control-solid"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  placeholder="motorcycle atv price"
                                  name="motorcycleAtvPrice"
                                  id="motorcycleAtvPrice"
                                  defaultValue={
                                    membership?.motorcycleAtvPrice
                                      ? membership?.motorcycleAtvPrice
                                      : values.motorcycleAtvPrice
                                  }
                                />
                              </div>
                            </div> */}
                            <div className="row mb-8">
                              <div className="col-xl-3">
                                <div className="fs-6 fw-bold mt-2 mb-3">
                                  Bicycle Price
                                </div>
                              </div>
                              <div className="col-xl-9 fv-row fv-plugins-icon-container">
                                <input
                                  type="text"
                                  className="form-control form-control-solid"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  name="bicyclePrice"
                                  id="bicyclePrice"
                                  defaultValue={
                                    membership?.bicyclePrice
                                      ? membership?.bicyclePrice
                                      : values.bicyclePrice
                                  }
                                />
                              </div>
                            </div>
                            <div className="row mb-8">
                              <div className="col-xl-3">
                                <div className="fs-6 fw-bold mt-2 mb-3">
                                  Vehicle Limit under Price
                                </div>
                              </div>
                              <div className="col-xl-9 fv-row fv-plugins-icon-container">
                                <input
                                  type="text"
                                  className="form-control form-control-solid"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  name="vehicleLimit"
                                  id="vehicleLimit"
                                  defaultValue={
                                    membership?.vehicleLimit
                                      ? membership?.vehicleLimit
                                      : values.vehicleLimit
                                  }
                                />
                                <div className="fv-plugins-message-container invalid-feedback"></div>
                              </div>
                            </div>
                            <div className="row mb-8">
                              <div className="col-xl-3">
                                <div className="fs-6 fw-bold mt-2 mb-3">
                                  No. of Dependent users allowed
                                </div>
                              </div>
                              <div className="col-xl-9 fv-row fv-plugins-icon-container">
                                <input
                                  type="text"
                                  className="form-control form-control-solid"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  name="additionalDrivers"
                                  id="additionalDrivers"
                                  defaultValue={
                                    membership?.additionalDrivers
                                      ? membership?.additionalDrivers
                                      : values.additionalDrivers
                                  }
                                />
                                <div className="fv-plugins-message-container invalid-feedback"></div>
                              </div>
                            </div>
                            <div className="row mb-8">
                              <div className="col-xl-3">
                                <div className="fs-6 fw-bold mt-2 mb-3">
                                  Price for adding Dependent user
                                </div>
                              </div>
                              <div className="col-xl-9 fv-row fv-plugins-icon-container">
                                <input
                                  type="text"
                                  className="form-control form-control-solid"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  name="additionalDriversPrice"
                                  id="additionalDriversPrice"
                                  defaultValue={
                                    membership?.additionalDriversPrice
                                      ? membership?.additionalDriversPrice
                                      : values.additionalDriversPrice
                                  }
                                />
                                <div className="fv-plugins-message-container invalid-feedback"></div>
                              </div>
                            </div>
                            <div className="row mb-8">
                              <div className="col-xl-3">
                                <div className="fs-6 fw-bold mt-2 mb-3">
                                  Waiting Period
                                </div>
                              </div>
                              <div className="col-xl-9 fv-row fv-plugins-icon-container">
                                <input
                                  type="text"
                                  className="form-control form-control-solid"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  name="waitingPeriod"
                                  id="waitingPeriod"
                                  defaultValue={
                                    membership?.waitingPeriod
                                      ? membership?.waitingPeriod
                                      : values.waitingPeriod
                                  }
                                />
                              </div>
                            </div>
                            <div className="row mb-8">
                              <div className="col-xl-3 ">
                                <div className="fs-6 fw-bold mt-2 mb-3">
                                  <span className="required">Select Services</span>
                                </div>
                              </div>
                              <div className="select-service-field membership-form-check col-xl-9 fv-row fv-plugins-icon-container d-flex flex-wrap checkbox">
                                <Select
                                  name="service_id"
                                  closeMenuOnSelect={false}
                                  options={serviceOptions}
                                  value={allTechs}
                                  onChange={handleSelect}
                                  isMulti
                                  styles={colourStyles}
                                  placeholder="Select Services"
                                />
                                {!serviceMsg == false && (
                                  <p className="text-danger">{serviceMsg}</p>
                                )}
                              </div>
                            </div>
                            {/*  */}
                            <div className="row mb-8">
                              <div className="col-xl-3">
                                <div className="fs-6 fw-bold mt-2 mb-3">
                                  Description
                                </div>
                              </div>
                              <div className="col-xl-9 fv-row fv-plugins-icon-container">
                                <textarea
                                  rows="3"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  name="description"
                                  id="description"
                                  className="form-control form-control-solid"
                                  defaultValue={
                                    values.description
                                  }
                                ></textarea>
                                <div className="fv-plugins-message-container invalid-feedback"></div>
                              </div>
                            </div>
                            <div className="separator mb-6"></div>
                            <div className="d-flex justify-content-end">
                              <Link
                                to="/manage-membership"
                                type="reset"
                                data-kt-contacts-type="cancel"
                                className="btn btn-light me-3"
                              >
                                Cancel
                              </Link>
                              {!btnLoading ? (
                                <button
                                  onClick={handleSubmit}
                                  type="submit"
                                  className="btn btn-primary"
                                >
                                  <span className="indicator-label">Save</span>
                                </button>
                              ) : (
                                <button
                                  className="btn btn-primary py-0"
                                  disabled={btnLoading ? true : false}
                                >
                                  <div
                                    className="spinner-border w-80"
                                    role="status"
                                  >
                                    <span className="visually-hidden">
                                      Loading...
                                    </span>
                                  </div>
                                </button>
                              )}
                            </div>
                            <div></div>
                          </form>
                        )}
                      </Formik>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              loader()
            )}
          </div>
        </div>
      </Layout>
    </React.Fragment>
  );
};
const mapStateToProps = (state) => ({
  loading: state,
});

export default connect(mapStateToProps, { ManageServiceList })(EditMembership);
